// extracted by mini-css-extract-plugin
export default {"formContainer":"FormSection_formContainer__rPIO7","formBox":"FormSection_formBox__cyDNV"};